import {MultipleChoiceOption} from '#apollo/schema';
import {Checkbox} from '#component/base';

import {MultiSelectProps} from './MultiSelect.types';

import * as css from './MultiSelect.css';

/**
 * The MultiSelect component is used to present a set of checkboxes where multiple inputs can be selected.
 * If the list of answer options is greater than 7, the answer options will be displayed in 2 columns.
 * If the list of answer options is 7 or less, the answer options will be displayed in 1 column.
 */
export const MultiSelect = ({onChange, options = [], value = []}: MultiSelectProps) => {
  if (options.length > 7) {
    const mid = Math.ceil(options.length / 2);
    const leftCol = options.slice(0, mid);
    const rightCol = options.slice(mid);

    const rowsCount = leftCol.length;

    // create an object holding the left column option and right column option in each row of answers so that
    // the two columns are displayed in a table with vertically and horizontally aligned elements
    const merged = [];
    type mergedObject = {
      left: MultipleChoiceOption;
      right: MultipleChoiceOption | null;
    };

    for (let i = 0; i < rowsCount; i++) {
      let rightVal = null;
      if (rightCol) {
        rightVal = rightCol[i];
      }
      const constructedRow: mergedObject = {
        left: leftCol[i],
        right: rightVal,
      };
      merged.push(constructedRow);
    }
    return (
      <fieldset>
        {merged.map(({left, right}) => (
          <span className={css.columnStyles} key={left.id}>
            <Checkbox
              checked={!!value.length && (value as string[]).includes(left.id)}
              label={left.text}
              onChange={onChange}
              value={left.id}
            />
            {right && (
              <Checkbox
                checked={!!value.length && (value as string[]).includes(right.id)}
                label={right.text}
                onChange={onChange}
                value={right.id}
              />
            )}
          </span>
        ))}
      </fieldset>
    );
  } else {
    return (
      <fieldset>
        {options.map(({id, text}) => (
          <span className={css.checkboxStyles} key={id}>
            <Checkbox
              key={id}
              checked={!!value.length && (value as string[]).includes(id)}
              label={text}
              onChange={onChange}
              value={id}
            />
          </span>
        ))}
      </fieldset>
    );
  }
};
